// Pronto: ปิดการแสดง "รับสินค้าที่ร้าน" ของธีม (ใช้บล็อก TRY IN STORE ของเราแทน)
// เดิมไฟล์นี้มีคลาสต้นฉบับของธีม + โค้ดชุดนี้ถูกแปะต่อท้าย → import/class ซ้ำ ทั้งไฟล์ error ไม่ทำงาน (แก้ 2026-10-14)
// ต้นฉบับเต็มสำรองไว้ที่ app.weedjai storage/app/theme_bak_20261014_jsfix/assets__local-pickup.js
import { Component } from '@theme/component';

class LocalPickup extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute('hidden', '');
  }
}

if (!customElements.get('local-pickup')) {
  customElements.define('local-pickup', LocalPickup);
}
